import React, { useEffect, useState } from 'react';
import { getRoles } from '../../helpers/token';
import AuthorBlacklist from './Actions/AuthorBlacklist';
import ChangeRoles from './Actions/ChangeRoles';
import CuratorMenu from './CuratorMenu';

const BlogMenu = props => {
  const [roles, setRoles] = useState(undefined);

  useEffect(() => {
    setRoles(getRoles());
  }, []);

  const isTeam = roles && roles.indexOf('team') !== -1;
  const isAdmin = roles && roles.indexOf('admin') !== -1;

  const { author } = props;

  return (
    <>
      {isTeam && (
        <CuratorMenu
          component={
            <>
              <AuthorBlacklist author={author} />
              {isAdmin && (
                <>
                  <ChangeRoles author={author} isCurator={props.isCurator} />
                  <ChangeRoles
                    author={author}
                    isCurator={props.isVideo}
                    isVideo
                  />
                </>
              )}
            </>
          }
        />
      )}
    </>
  );
};

export default BlogMenu;
